import { api } from '@shared-runtime/api';

import type {
  PostDeleteFiatBankAccountParams,
  PostDeleteFiatBankAccountResult,
} from './apiSchema';
import { normalizePostDeleteFiatBankAccount } from './helpers';
import type { DeleteFiatBankAccountResponse } from './schema';

export async function fetchPostDeleteFiatBankAccount(
  accountId: PostDeleteFiatBankAccountParams,
): Promise<DeleteFiatBankAccountResponse> {
  return api.nts
    .post<PostDeleteFiatBankAccountResult>(
      `/fiat/delete-bank-account/${accountId}`,
      {
        method: 'private/fiat/delete-bank-account',
      },
    )
    .normalize(normalizePostDeleteFiatBankAccount);
}
